const CONTROLS = {
    CLIENT: { top: "w", right: "d", bottom: "s", left: "a" },
    GUEST: { top: "ArrowUp", right: "ArrowRight", bottom: "ArrowDown", left: "ArrowLeft" }
}

export default CONTROLS